const NoCategoriesAvailable = () => {
  return (
    <>
      <div className="text-[22px] md:text-[32px] text-black font-light leading-[32px] text-center">
        No Categories Available
      </div>
    </>
  );
};
export default NoCategoriesAvailable;
